import LiPage from "./src/index.vue";

LiPage.install = function (Vue) {
  Vue.component(LiPage.name, LiPage);
};

export default LiPage;
